if (!customElements.get('size-chart')) {
  class sizeChart extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Basic chart tabbing
      const chart_tabs = this.querySelectorAll('[data-tab-target]');
      const chart_contents = this.querySelectorAll('[data-tab-content]');
      chart_tabs.forEach(btn => {
        btn.addEventListener('click', () => {
          const target = btn.dataset.tabTarget;
          chart_tabs.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          chart_contents.forEach(c =>
            c.classList.toggle('sp-hidden', c.dataset.tabContent !== target)
          );
        });
      });

      // Size chart section tabs
      const radioButtons = this.querySelectorAll('input[name="section-toggle"]');
      const sections = this.querySelectorAll('[data-tab-section]');

      radioButtons.forEach(radio => {
        radio.addEventListener('change', function () {
          const target = this.value;

          sections.forEach(section => {
            const isActive = section.getAttribute('data-tab-section') === target;
            section.classList.toggle('sp-hidden', !isActive);
          });
        });
      });

      // Fullpage controls
      document.querySelectorAll('[data-category-target]').forEach(trigger => {
        trigger.addEventListener('click', () => {
          const target = trigger.dataset.categoryTarget;
          document.querySelectorAll('[data-category-tiles], [data-category-content]').forEach(el => el.classList.add('sp-hidden'));
          document.querySelectorAll(`[data-category-content="${target}"]`).forEach(el => el.classList.remove('sp-hidden'));
          document.querySelectorAll('[data-category-target]').forEach(el => el.classList.remove('active'));
          document.querySelectorAll(`[data-category-target="${target}"]`).forEach(el => el.classList.add('active'));
          window.scrollTo({ top: 0, behavior: 'smooth' });

          const url = new URL(window.location);
          url.searchParams.set('guide', target);
          window.history.replaceState({}, '', url);
        });
      });

      const params = new URLSearchParams(window.location.search);
      const guideParam = params.get('guide');

      if (guideParam) {
        requestAnimationFrame(() => {
          const matchingTab = document.querySelector(`[data-category-target="${guideParam}"]`);
          if (matchingTab) {
            matchingTab.click();
          } else {
            console.warn(`No tab found for guide=${guideParam}`);
          }
        });
      }
    }
  }

  customElements.define('size-chart', sizeChart);
}
